import { HttpRequest, HttpEvent, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { LogoutAction } from '../actions/user/user.actions';
import { getAuthToken } from '../selectors/user.selectors';
import { EnvironmentResolveService } from '../services/environment-resolve/environment-resolve.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(private store: Store<AppState>, private erService: EnvironmentResolveService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.erService.environmentERS && request.url !== this.erService.environmentERS.uploadUrl) {
      this.store.select(getAuthToken).subscribe((authToken: string) => {
        if (
          !request.url.includes('upload') &&
          !request.url.includes('files') &&
          !request.url.includes('download') &&
          !request.headers.has('Content-Type')
        ) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });
        }
      });
    }

    // pass the request forward for processing
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.store.dispatch(LogoutAction());
        }
        return throwError(error);
      })
    );
  }
}
